import React, {useState, useEffect} from 'react';
import { Navbar, Nav, Image, Button } from 'react-bootstrap';
import translate from '../../../../translate';
import BrandinWbd from '../../../Landing2.0/assets/icons/menu-logo-white.svg';
import './navbarCard.css'

const NavbarCard = ({...props}) => {
  const {lan} = props;
  const transl = translate[lan].LandingCard.navbar;

  return(
    <Navbar 
      expand='false'
      collapseOnSelect={true}
      className='custom-navbar-card'
    >
      <div className='responsive-brand-card'>
        <Navbar.Brand className='brand-logo-card'>
          <Image src={BrandinWbd} width={100} height={35}/>
        </Navbar.Brand>
        <Button className='login-btn-card' onClick={()=>window.open(window.location.origin + '/login','_blank')}>{transl.btn_login}</Button>
      </div>
    </Navbar>
  )
}

export default NavbarCard